import {
  ComboBox,
  IComboBox,
  IComboBoxOption,
  IconButton,
  Label,
  Panel,
  PanelType,
  TooltipHost,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import {
  IconButtonStyles,
  emojiIcon,
  hostStyles,
} from "../../utils/helpers/stylesHelper";
import { FormEvent, useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../components/Panel/PanelHeader";
import { useDetallePersona } from "../../hooks/useDetallePersona";
import { PanelFooter } from "../../components/Panel/PanelFooter";
import { useAsignarSupervisor } from "../../hooks/useAsignarSupervisor";
import { IAsignacionSupervisor } from "../../Interfaces/IPersona";
import { useParams } from "react-router-dom";
import { MensajeBar } from "../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../components/generic/IndicadorProgress";
import React from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { send } from "process";

interface IAsignarSupervisor {
  disabled: boolean | undefined;
  checked: boolean | undefined;
  supervisor: string | undefined;
  personaId: string | undefined;
  dataPersona: any;
  reload?: () => void
}

export const EsEnrolado = (props: IAsignarSupervisor) => {

  const { id } = useParams();
  const [dataRequest, setDataRequest] = useState<IAsignacionSupervisor>(null!);
  const [supervisoresCombo, setSupervisoresCombo] = useState<IComboBoxOption[]>([]);
  const [search, setSearch] = useState("");

  //const { getDataListSupervisores, supervisoresCombo } = useDetallePersona();
  //const { _onClickAsignar, response, ocultarMensaje, isSend } = useAsignarSupervisor(setDataRequest);

  const comboBoxRefPersona = React.useRef<IComboBox>(null);
  const _openOptionPersona = React.useCallback(() => comboBoxRefPersona.current?.focus(true), []);

  //const { _onClickAsignar, response, ocultarMensaje, isSend } = useAsignarSupervisor(setDataRequest);

  const [isOpenAsignacion, { setTrue: openAsignacion, setFalse: dismissAsignacion },] = useBoolean(false);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] = useBoolean(false);

  const [response, setResponse] = useState<IResponsePost>(null!);
  const [tipoMensaje, setTipoMensaje] = useState(0);
  const [ocultaBoton, setOcultaBoton] = useState(false);


  useEffect(() => {
    if (isOpenAsignacion) {
      //ComboSupervisorAPI();
      //ocultarMensaje();
      setDataRequest(null!);
    } else {
      setOcultaBoton(false)
    }
  }, [isOpenAsignacion]);



  useEffect(() => {

    if (tipoMensaje === 1) {

      setTimeout(() => {
        setTipoMensaje(0)
        setDataRequest(null!);
        dismissAsignacion()

      }, 2000);

    }

  }, [tipoMensaje])
  
  return (
    <>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-depth-8 ms-fontColor-themePrimary--hover">
        <br />
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <div className="ms-Grid-col ms-sm11 ms-md11 ms-lg11">
            <Label>¿Está Enrolado?: SI </Label>
            <br />
          </div>
        </div>
      </div>
    </>
  );
};
